var map = {
	"./k-async.vue": "bd01",
	"./k-base-form.vue": "3b04",
	"./k-bread-crumb.vue": "55d5",
	"./k-catalog-tree.vue": "4ffc",
	"./k-catalog.vue": "6336",
	"./k-code-editor.vue": "08c2",
	"./k-common-menu.vue": "66ae",
	"./k-date-filter.vue": "1b87",
	"./k-edit-table.vue": "2339",
	"./k-editable-cell.vue": "56cc",
	"./k-editor.vue": "de03",
	"./k-filter-only.vue": "c5b1",
	"./k-filter.vue": "d630",
	"./k-json-editor.vue": "07b3",
	"./k-new-folder.vue": "444e",
	"./k-period-input.vue": "7eea",
	"./k-role-input.vue": "bd2a",
	"./k-search-user.vue": "13e2",
	"./k-sub-bread.vue": "07af",
	"./k-switch.vue": "a5bc",
	"./k-table.vue": "f247",
	"./k-tag-info.vue": "bd47",
	"./k-tag-input.vue": "9317",
	"./k-tag.vue": "d8aa",
	"./k-type-input.vue": "ab44"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5678";